const API_URL =
  process.env.NODE_ENV === "production"
    ? ""
    : process.env.REACT_APP_BACKEND_URL || "http://localhost:5050";

let isRefreshing = false;
let refreshQueue = [];

function processQueue(newToken) {
  refreshQueue.forEach((cb) => cb(newToken));
  refreshQueue = [];
}

function failQueue() {
  refreshQueue.forEach((cb) => cb(null));
  refreshQueue = [];
}

async function refreshAccessToken() {
  const refreshToken = localStorage.getItem("refreshToken");
  if (!refreshToken) return null;

  const response = await fetch(`${API_URL}/api/users/refresh-token`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ refreshToken }),
  });

  if (!response.ok) {
    return null;
  }

  const data = await response.json();
  localStorage.setItem("token", data.token);
  localStorage.setItem("refreshToken", data.refreshToken);
  return data.token;
}

/**
 * Authenticated fetch wrapper that:
 * 1. Attaches x-auth-token header automatically
 * 2. On 401, attempts to refresh the token
 * 3. If refresh succeeds, retries the original request
 * 4. If refresh fails, clears tokens and redirects to /login
 */
export async function authFetch(url, options = {}) {
  const token = localStorage.getItem("token");

  const headers = {
    ...options.headers,
  };

  // Don't override x-auth-token if already set, and don't set for FormData
  if (token && !headers["x-auth-token"]) {
    headers["x-auth-token"] = token;
  }

  const response = await fetch(url, { ...options, headers });

  if (response.status === 401) {
    // If already refreshing, wait for the refresh to complete
    if (isRefreshing) {
      return new Promise((resolve) => {
        refreshQueue.push((newToken) => {
          if (newToken) {
            headers["x-auth-token"] = newToken;
            resolve(fetch(url, { ...options, headers }));
          } else {
            resolve(response);
          }
        });
      });
    }

    isRefreshing = true;

    try {
      const newToken = await refreshAccessToken();

      if (newToken) {
        processQueue(newToken);
        // Retry original request with new token
        headers["x-auth-token"] = newToken;
        return fetch(url, { ...options, headers });
      } else {
        failQueue();
        // Refresh failed — clear everything and redirect
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        window.location.href = "/login";
        return response;
      }
    } catch {
      failQueue();
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      window.location.href = "/login";
      return response;
    } finally {
      isRefreshing = false;
    }
  }

  return response;
}
